import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import SocialPost from 'components/SocialPost';
import { useGetHashtagDetailsQuery } from 'services';
import { setLastScrolling } from 'store/feeds';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from 'components/Common/Loader';
import 'pages/SocialFeed/styles.scss';
import { useParams } from 'react-router-dom';
import HashTagHeader from 'components/Common/HashtagTop/HashTagHeader';
import useTranslate from 'hooks/useTranslate';

const HashtagProfile: React.FC = () => {
	const { id } = useParams();
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const payload: any = {
		page: currentPage,
		limit: 2,
		id,
	};

	const { data: { docs: { results = [], hashTag = {} } = {}, meta = {} } = {}, refetch } =
		useGetHashtagDetailsQuery(payload);
	const [myPosts, setMyPosts] = useState<any>([]);

	useEffect(() => {
		if (results.length > 0) {
			setMyPosts((prev: any) => (currentPage === 1 ? results : [...prev, ...results]));
		} else if (currentPage === 1) {
			setMyPosts([]);
		}
	}, [results, currentPage]);

	useEffect(() => {
		setCurrentPage(1);
	}, [id]);

	const handleScroll = (event: any) => {
		const scrollTop = event.target.scrollTop;
		setLastScrolling(scrollTop);
	};

	const loadMoreFunc = () => {
		setCurrentPage((prev) => prev + 1);
	};

	const refreshFeeds = () => {
		refetch()
			.then((_res: any) => {})
			.catch(() => {});
	};

	return (
		<div className="social-feed">
			<div className="social-feed-left">
				<Stack className="social-feed-posts">
					<HashTagHeader data={hashTag} refetchData={refreshFeeds} />
					{myPosts?.length > 0 ? (
						<InfiniteScroll
							dataLength={myPosts.length}
							next={loadMoreFunc}
							hasMore={meta?.hasNextPage}
							loader={
								myPosts.length >= 1 && (
									<div className="d-flex justify-content-center align-items-center">
										<Loader />
									</div>
								)
							}
							scrollableTarget={`infiniteDiv-social-feeds`}
							scrollThreshold="300px"
							refreshFunction={loadMoreFunc}
							pullDownToRefreshThreshold={50}
							onScroll={handleScroll}
							pullDownToRefreshContent={
								<h3 style={{ textAlign: 'center' }}>
									&#8595; {translate('Common.pullDownToRefresh')}
								</h3>
							}
							releaseToRefreshContent={
								<h3 style={{ textAlign: 'center' }}>
									&#8593; {translate('Common.releaseToRefresh')}
								</h3>
							}
						>
							{myPosts.length > 0 ? (
								myPosts.map((post: any, index: number) => (
									<SocialPost
										post={post}
										key={`${post?.postId}-${index}`}
										refetch={refreshFeeds}
										type="hash"
										show={true}
									/>
								))
							) : (
								<Stack>{translate('Common.noDataFound')}</Stack>
							)}
						</InfiniteScroll>
					) : (
						<Stack>
							<p className="mb-0">{translate('Common.noPostFound')}</p>
						</Stack>
					)}
				</Stack>
			</div>
		</div>
	);
};

export default HashtagProfile;
